(() => {
  const slugify = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const init = (root = document) => {
    root.querySelectorAll('[data-article-editorial]').forEach((section) => {
      if (section.dataset.tocInitialized) return;
      const content = section.querySelector('.m-article__content');
      const toc = section.querySelector('.m-article__toc');
      const list = toc?.querySelector('.m-article__toc-list');
      if (!content || !toc || !list) return;
      section.dataset.tocInitialized = 'true';
      const headings = Array.from(content.children).filter(node => node.tagName === 'H2');
      if (headings.length < 5) return;
      headings.forEach((heading, index) => {
        const base = heading.id || slugify(heading.textContent) || `article-section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (document.getElementById(id) && document.getElementById(id) !== heading) id = `${base}-${suffix++}`;
        heading.id = id;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${id}`;
        link.textContent = heading.textContent.trim();
        link.addEventListener('click', () => {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        });
        item.appendChild(link);
        list.appendChild(item);
      });
      toc.hidden = false;
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
